'use client';
import { useState } from 'react';
import AppModal from '../AppModal';
import './style.css';

type TAppHelperModalProps = {
  parentOpen: boolean;
};

const AppHelperModal = ({ parentOpen }: TAppHelperModalProps) => {
  const [open, setOpen] = useState(parentOpen);

  return (
    <AppModal open={open} onHide={() => setOpen(false)} header="Ajuda">
      <p></p>
    </AppModal>
  );
};

export default AppHelperModal;
